import { InjectionToken, Signal } from '@angular/core'

/** A menu item for the dynamically rendered overflow menu group. */
export interface OverflowMenuItem {
	readonly label: string
	readonly icon: string|null
	readonly run: () => void
}

/** Provides the label, icon, and items for the dynamically rendered overflow menu group. */
export interface OverflowMenuSource {
	/** The label for the dynamically rendered overflow menu group. */
	readonly menuLabel: Signal<string>
	/** Material icon ligature shown with the overflow submenu group button label. */
	readonly menuIcon: Signal<string|null>
	/** The items for the dynamically rendered overflow menu group. */
	readonly menuItems: Signal<ReadonlyArray<OverflowMenuItem>>
}

/** Used by `ResponsiveContentElement` to inject the label and items for the dynamically rendered overflow menu group. */
export const OVERFLOW_MENU_SOURCE = new InjectionToken<OverflowMenuSource>('OVERFLOW_MENU_SOURCE')
